import { render, staticRenderFns } from "./phone-today.vue?vue&type=template&id=212a15b0&scoped=true"
import script from "./phone-today.vue?vue&type=script&lang=js"
export * from "./phone-today.vue?vue&type=script&lang=js"
import style0 from "./phone-today.vue?vue&type=style&index=0&id=212a15b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212a15b0",
  null
  
)

export default component.exports